/* eslint-disable */
import React, { FC, ReactNode, useState } from 'react';
import { useMediaQuery } from 'react-responsive';
import styled, { css } from 'styled-components';
import { Col, Row, Typography } from 'antd';
import theme from '~/constants/theme';
import { useIsMobile } from '~/hooks/useScreenSizes';
import paths from '~/pages/paths';
import { useTranslation } from 'react-i18next';
import TermsAndConditionsModal from '~/pages/ksa/contract/components/TermsAndConditionsModal';

interface Props {
  left?: ReactNode;
  content: ReactNode;
  right?: ReactNode;
  footer?: ReactNode;
  className?: string;
}

const WizardContent: FC<Props> = (props) => {
  const { left, content, right, className } = props;
  const { t } = useTranslation();
  const [termsModalOpen, setTermsModalOpen] = useState(false);
  const footer: any = (
    <div className="footer">
      <Row justify="end">
        <Col span={10}>
          <Typography.Paragraph className="footerText">
            {t('Copyright 2025 Network International. All Rights Reserved.')}
          </Typography.Paragraph>
        </Col>
        <Col
          span={14}
          style={{
            display: 'flex',
            flexDirection: 'row',
            gap: 16,
            justifyContent: 'flex-end',
            paddingRight: '8%',
          }}
        >
          <Typography.Paragraph>
            <a
              className="footerText"
              target="_blank"
              rel="noreferrer"
              href={'https://docs.ngenius-payments.com/'}
            >
              {t('Developers Guide')}
              {/*<VectorIcon style={{ color: 'transparent', fontSize: 15, marginLeft: 6 }} />*/}
            </a>
          </Typography.Paragraph>
          <Typography.Paragraph>
            <FooterLinkButton
              className="footerText"
              onClick={() => setTermsModalOpen(true)}
            >
              {t('Terms and Conditions ')}
            </FooterLinkButton>
          </Typography.Paragraph>
          <Typography.Paragraph>
            <a
              className="footerText"
              target="_blank"
              rel="noreferrer"
              href={'https://www.network.ae/en/privacy-notice'}
            >
              {t('Privacy Policy')}
            </a>
          </Typography.Paragraph>
        </Col>
      </Row>
    </div>
  );

  const isTablet = useMediaQuery({ maxWidth: theme.breakpoints.lg });
  const isMobile = useIsMobile();
  const isServies = location.pathname === paths.wizard.services;

  const view = isMobile ? (
    <Container left={left} right={right} className={className}>
      {left && <div className="WizardContent-Corner WizardContent-CornerLeft">{left}</div>}
      <div className="WizardContent-Content">
        {content}
        {isTablet && right && isServies && (
          <div className="WizardContent-BottomButton">{right}</div>
        )}
      </div>
      {!isTablet && right && (
        <div className="WizardContent-Corner WizardContent-CornerRight">{right}</div>
      )}
      <div className="WizardContent-Corner WizardContent-CornerRight">{footer}</div>
    </Container>
  ) : isTablet ? (
    <GridContainer left={!!left} right={!!right} className={className}>
      <div className="MainContent">{content}</div>
      {right && <div className="Corner Right">{right}</div>}
    </GridContainer>
  ) : (
    <GridContainer left={!!left} right={!!right} className={className}>
      {left && <div className="Corner Left">{left}</div>}
      <div className="MainContent">{content}</div>
      {right && <div className="Corner Right">{right}</div>}
      {footer && <div className="Footer">{footer}</div>}
    </GridContainer>
  );

  return (
    <>
      {view}
      <TermsAndConditionsModal
        open={termsModalOpen}
        onAgree={() => setTermsModalOpen(false)}
        onClose={() => setTermsModalOpen(false)}
        readOnly={true}
      />
    </>
  );
};

type WizardContentStyleProps = { left?: ReactNode; right?: ReactNode };

const Container = styled.div<WizardContentStyleProps>`
  display: flex;
  flex: 1;

  .WizardContent-Corner {
    position: sticky;
    top: 55px;
    height: calc(100vh - 192px);
    display: flex;
    flex-direction: column;
    flex: 1;
    padding: 0 44px 0;
    max-width: 357px;
  }
  .WizardContent-CornerRight {
    justify-content: flex-end;
  }
  .WizardContent-Content {
    background-color: transparent !important;

    display: flex;
    flex-direction: column;
    ${({ left, right }) =>
    left && right
      ? css`
            width: 700px;
          `
      : undefined}
  }

  .WizardContent-BottomButton {
    margin-top: 28px;
    button {
      width: unset;
      min-width: calc(50% - 10px);
    }
  }

  @media (max-width: ${theme.breakpoints.xl + 32}px) {
    .WizardContent-Content {
      background-color: transparent !important;

      ${({ left, right }) =>
    left && right
      ? css`
              width: 50vw;
            `
      : undefined}
    }
  }

  @media (max-width: ${theme.breakpoints.lg}px) {
    background-color: transparent !important;

    .WizardContent-Content {
      background-color: transparent !important;

      ${({ left, right }) =>
    left && right
      ? css`
              width: calc(70vw - 32px);
            `
      : undefined}
    }
    .WizardContent-CornerLeft {
      width: calc(30vw - 32px);
    }
    .WizardContent-CornerRight {
      display: none;
    }
  }
  @media (max-width: ${theme.breakpoints.md}px) {
    background-color: transparent !important;

    padding: 0;
    .WizardContent-CornerLeft {
      display: none;
    }
    .WizardContent-Content {
      width: 100%;
    }
    .WizardContent-BottomButton {
      button {
        width: 100%;
      }
    }
  }
  @media (max-width: ${theme.breakpoints.sm}px) {
    background-color: transparent !important;

    .WizardContent-BottomButton {
      margin-top: 0;
    }
  }
`;
const GridContainer = styled.div<any>`
  display: grid;
  grid-template-rows: auto 1fr auto;
  ${({ left, right }) =>
    left && right
      ? css`
          grid-template-columns: 20vw 50vw 30vw;
        `
      : css`
          grid-template-columns: 1fr;
        `}
  grid-template-areas:
    ${({ left, right }) => (left && right ? `"left content right"` : `"content"`)};

  .Left {
    grid-area: left;
    position: sticky;
    top: 55px;
    height: calc(100vh - 192px);
    padding: 0 44px;

    overflow: auto;
  }
  .footer {
    margin-top: 40px;
    //padding-top: 40px;
    background: transparent;
    padding-left: 6%;
    //padding-right: 8%;
    height: 20px;

    .footerText {
      color: #1c2027;
      font-family: Inter, sans-serif;
      font-size: 14px;
      font-style: normal;
      font-weight: 400;
      line-height: 24px; /* 171.429% */
      letter-spacing: 0.14px;
    }
  }
  .MainContent {
    border-radius:16px;
    background: #FFF;
    // min-height:989px;
    grid-area: content;
    padding: 32px 36px;
    // margin-top: 40px;
    margin-right: 32px;
    margin-left: 32px;

    .ant-input-affix-wrapper,
    input.ant-input:not(textarea),
    .ant-select {
      max-width: 570px !important;
      width: 100% !important;
    }

    .ant-input-affix-wrapper {
      height: 56px !important;
      border-radius: 8px !important;
      padding: 0 12px !important;
      display: flex !important;
      align-items: center !important;

      input.ant-input {
        height: 100% !important;
        padding: 0 !important;
        border: none !important;
        box-shadow: none !important;
        font-size: 14px !important;
      }

      .ant-input-suffix {
        display: flex !important;
        align-items: center !important;
        margin-left: 10px !important;
      }
    }

    input.ant-input:not(textarea):not(.ant-input-affix-wrapper input) {
      height: 56px !important;
      border-radius: 8px !important;
      padding: 16px 12px !important;
      font-size: 14px !important;
    }

    textarea.ant-input {
      width: 100% !important;
      border-radius: 8px !important;
      padding: 12px !important;
      font-size: 14px !important;
    }

    .ant-select-single:not(.ant-select-customize-input) .ant-select-selector {
      height: 56px !important;
      border-radius: 8px !important;
      padding: 0 12px !important;
      display: flex !important;
      align-items: center !important;
    }
    .ant-select-single .ant-select-selector .ant-select-selection-search-input {
      height: 56px !important;
    }
    .ant-select-single .ant-select-selector .ant-select-selection-item,
    .ant-select-single .ant-select-selector .ant-select-selection-placeholder {
      line-height: 56px !important;
      display: flex !important;
      align-items: center !important;
    }
    #hinIccon, button#hinIccon, .ant-btn-icon-only:not(.counterBtn) {
      width: 24px !important;
      min-width: 24px !important;
      max-width: 24px !important;
      height: 24px !important;
      min-height: 24px !important;
      max-height: 24px !important;
      padding: 0 !important;
      flex-shrink: 0 !important;
      border: none !important;
      box-shadow: none !important;
      background: transparent !important;
    }
    .ant-switch {
      width: 44px !important;
      min-width: 44px !important;
      max-width: 44px !important;
      height: 22px !important;
      min-height: 22px !important;
      max-height: 22px !important;
      line-height: 22px !important;
      border-radius: 100px !important;
      padding: 0 !important;
      background-color: #bfbfbf !important;
      background-image: none !important;
      border: none !important;

      &.ant-switch-checked {
        background-color: #1890ff !important;
      }

      .ant-switch-handle {
        width: 18px !important;
        height: 18px !important;
        top: 2px !important;
        left: 2px !important;
        &::before {
          background-color: #ffffff !important;
          border-radius: 50% !important;
          box-shadow: 0 2px 4px 0 rgba(0, 35, 11, 0.2) !important;
        }
      }

      &.ant-switch-checked .ant-switch-handle {
        left: calc(100% - 20px) !important;
      }
    }
  }

  .Right {
    grid-area: right;
    position: sticky;
    top: 15px;
    height: calc(100vh - 192px);
    //padding: 0 44px;
    overflow: auto;
  }

  .BottomRight {
    margin-top: 10px;
  }

  .Footer {
    grid-row: 3;
    grid-column: 1 / -1;
    padding: 0 44px;
  }

  //Tablet (below 'lg')
  @media (max-width: ${theme.breakpoints.lg}px) {
    grid-template-columns: 62vw 38vw;
    grid-template-areas: 'content right';
  }
`;

export default WizardContent;

const FooterLinkButton = styled.button`
  background: none;
  border: none;
  padding: 0;
  cursor: pointer;
  font: inherit;
  color: inherit;
  text-decoration: none;
  display: inline;

  &:hover {
    text-decoration: underline;
    opacity: 0.8;
  }
`;
